/**
 * 移动端售后接口相关api
 */
import request from '@/utils/request'

/**
 * 展会加盟提交
 * @param formData
 * @returns {*}
 */
export function addFairJoin(formData) {
    return request({
        url: '/exhibition/add',
        method: 'post',
        data: formData
    })
}